import { render, staticRenderFns } from "./purchaseReturnDetail.vue?vue&type=template&id=4a1dab91"
import script from "./purchaseReturnDetail.vue?vue&type=script&lang=js"
export * from "./purchaseReturnDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports